import { combineReducers } from "redux";
import { Data, dataOf, fail, LOADING, NOT_STARTED } from "../../framework/data";
import { Actions } from "./actions";
import { AnnualFinals } from "./models";

export interface State {
    standings: Data<AnnualFinals>;
}

function reduceStandings(state: Data<AnnualFinals> = NOT_STARTED, action: Actions) {
    switch (action.type) {
        case "LOAD_ANNUAL_FINALS": return LOADING;
        case "LOAD_ANNUAL_FINALS_FAILED": return fail(action.error);
        case "LOAD_ANNUAL_FINALS_SUCCESS": return dataOf(action.payload.annualFinals);
        default: return state;
    }
}

export default combineReducers<State>({
    standings: reduceStandings
});
